
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_gwq0h_1egx8_97",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_1egx8_1",
  "trigger-expanded": "awsui_trigger-expanded_gwq0h_1egx8_119",
  "icon": "awsui_icon_gwq0h_1egx8_133",
  "root": "awsui_root_gwq0h_1egx8_151",
  "expand-button": "awsui_expand-button_gwq0h_1egx8_167",
  "expanded": "awsui_expanded_gwq0h_1egx8_174",
  "icon-container": "awsui_icon-container_gwq0h_1egx8_178",
  "icon-container-container": "awsui_icon-container-container_gwq0h_1egx8_182",
  "wrapper": "awsui_wrapper_gwq0h_1egx8_186",
  "wrapper-default": "awsui_wrapper-default_gwq0h_1egx8_194",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_1egx8_194",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_1egx8_198",
  "wrapper-container": "awsui_wrapper-container_gwq0h_1egx8_201",
  "header-deprecated": "awsui_header-deprecated_gwq0h_1egx8_216",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_1egx8_236",
  "header": "awsui_header_gwq0h_1egx8_216",
  "header-wrapper": "awsui_header-wrapper_gwq0h_1egx8_256",
  "header-button": "awsui_header-button_gwq0h_1egx8_268",
  "header-container-button": "awsui_header-container-button_gwq0h_1egx8_268",
  "header-container": "awsui_header-container_gwq0h_1egx8_268",
  "header-navigation": "awsui_header-navigation_gwq0h_1egx8_300",
  "header-text": "awsui_header-text_gwq0h_1egx8_334",
  "content": "awsui_content_gwq0h_1egx8_97",
  "content-default": "awsui_content-default_gwq0h_1egx8_341",
  "content-footer": "awsui_content-footer_gwq0h_1egx8_345",
  "content-expanded": "awsui_content-expanded_gwq0h_1egx8_349",
  "focusable": "awsui_focusable_gwq0h_1egx8_353",
  "click-target": "awsui_click-target_gwq0h_1egx8_364"
};
  